import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    echartHref: 'https://github.com/apache/incubator-echarts',
    elementUploadHref: 'https://element.eleme.cn/#/zh-CN/component/upload',
    draggableHref: 'https://github.com/SortableJS/Vue.Draggable',
    editorHref: "https://github.com/surmon-china/vue-quill-editor",
    markdownHref: "https://github.com/hinesboy/mavonEditor",
    excel: {
      exportExcelHref: 'https://panjiachen.github.io/vue-element-admin-site/zh/feature/component/excel.html#excel-%E5%AF%BC%E5%87%BA'
    },
    // 用户状态
    user: null,
    token: null
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setToken(state, token) {
      state.token = token
    },
    logout(state) {
      state.user = null
      state.token = null
      localStorage.removeItem('access_token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('savedUsername')
      localStorage.removeItem('ms_username')
      localStorage.removeItem('userRole')
    }
  },
  actions: {
    // 初始化用户状态
    initUserState({ commit }) {
      const token = localStorage.getItem('access_token')
      const userInfo = localStorage.getItem('userInfo')
      
      if (token && userInfo) {
        commit('setToken', token)
        commit('setUser', JSON.parse(userInfo))
      }
    }
  },
  modules: {
  }
})
